import React from 'react';

const Section6 = ({ imgWebp, imgJpg, videoSrc, imgAlt, title, subtitle, desc }) => {
  return (
    <section className="section-6">

      <div className='container'>
        <div className='other-row content'>
            <div className='col col-40'>
                <h3 className='title'>Why Our Systems Stand Out</h3>
            </div>
            <div className='col col-60'>
                <div className='content'>
                    <div className='items'>
                        <div className='d-flex mb-3'>
                            <div className='cb'>
                                <picture>
                                    <source type="image/png" srcSet="/img/mdi_water-filter.webp" />
                                    <img src="/img/blue-hand-water-icon.png" alt="Responsive" />
                                </picture>
                                <div className='line'></div>
                            </div>
                            <div className='item'>
                                <h4>Lifetime Warranty</h4>
                                <p className='desc'>Removes contaminants, ensuring safe and clean water for your entire home.</p>
                            </div>
                        </div>
                        <div className='d-flex mb-3'>
                            <div className='cb'>
                                <picture>
                                    <source type="image/png" srcSet="/img/mdi_water-filter.webp" />
                                    <img src="/img/blue-hand-water-icon.png" alt="Responsive" />
                                </picture>
                                <div className='line'></div>
                            </div>
                            <div className='item'>
                                <h4>Cleaner Water, Less Waste</h4>
                                <p className='desc'>Reduces plastic waste by eliminating the need for bottled water.</p>
                            </div>
                        </div>
                        <div className='d-flex mb-3'>
                            <div className='cb'>
                                <picture>
                                    <source type="image/png" srcSet="/img/mdi_water-filter.webp" />
                                    <img src="/img/blue-hand-water-icon.png" alt="Responsive" />
                                </picture>
                                <div className='line'></div>
                            </div>
                            <div className='item'>
                                <h4>Ongoing Upgrades</h4>
                                <p className='desc'>Save money over time by reducing water-related expenses.</p>
                            </div>
                        </div>
                        <div className='d-flex mb-3'>
                            <div className='cb'>
                                <picture>
                                    <source type="image/png" srcSet="/img/mdi_water-filter.webp" />
                                    <img src="/img/blue-hand-water-icon.png" alt="Responsive" />
                                </picture>
                                <div className='line'></div>
                            </div>
                            <div className='item'>
                                <h4>Customised Installation</h4>
                                <p className='desc'>Quick setup with professional support to get you started.</p>
                            </div>
                        </div>
                        <div className='d-flex mb-3'>
                            <div className='cb'>
                                <picture>
                                    <source type="image/png" srcSet="/img/mdi_water-filter.webp" />
                                    <img src="/img/blue-hand-water-icon.png" alt="Responsive" />
                                </picture>
                                <div className='line'></div>
                            </div>
                            <div className='item'>
                                <h4>Family-owned business with dedicated customer service</h4>
                                <p className='desc'>As a family-owned business, we prioritise long-term relationships over quick sales. You'll get honest advice, reliable systems, and ongoing support to ensure your water filtration performs exactly as it should.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

    </section>
  )
}

export default Section6;